import { useEffect, useState } from "react";
import MascotWithItems from "./MascotWithItems";
import LearnerChatBubble from "../../learner/bubbles/ChatBubble";
import InformationBubble from "../bubbles/InformationBubble";
import { mascotStyles } from "./MascotStyles";
import i18n from "../../../language/i18n";

interface MascotProps {
  userInformation?: any;
  userProfile?: any;
  userProfileSeason?: any;
  curriculumType?: any;
  inventoryItemDTOList?: any[];
  mode?: string;
  showText?: boolean;
  setShowText?: (show: boolean) => void;
  text?: string;
  subText?: string;
  primaryButtonText?: string;
  primaryButtonOnClick?: () => void;
  chatSize?: string;
  chatWelcomeText?: any;
  chatActivityId?: any;
  chatActivityTemplateId?: any;
  chatActivityTemplateType?: any;
  chatList?: any[];
  chatLoading?: boolean;
  sendMessageOnClick?: any;
  chatCanConvertAudio?: any;
  chatVoiceItemOwned?: boolean;
  chatCanDraw?: boolean;
  chatVoiceType?: string;
  chatVoiceLanguage?: string;
  chatActType?: string;
  chatPosition?: string;
  chatErrorText?: any;
  chatContinueText?: any;
  chatContinueOnClick?: any;
  chatActionList?: any[];
  onLoad?: () => void;
}

const Mascot = ({
  userInformation,
  userProfile,
  userProfileSeason,
  curriculumType,
  inventoryItemDTOList,
  mode,
  showText,
  setShowText = () => {},
  text,
  subText,
  primaryButtonText,
  primaryButtonOnClick,
  chatSize = "md",
  chatWelcomeText,
  chatActivityId,
  chatActivityTemplateId,
  chatActivityTemplateType,
  chatList = [],
  chatLoading = false,
  sendMessageOnClick,
  chatCanConvertAudio,
  chatVoiceItemOwned = true,
  chatCanDraw = true,
  chatVoiceType = "EKREM_VOICE",
  chatVoiceLanguage = "ENGLISH",
  chatActType = "DEFAULT_ACT",
  chatPosition = "LEFT",
  chatErrorText,
  chatContinueText,
  chatContinueOnClick,
  chatActionList = [],
  onLoad,
}: MascotProps) => {
  const [chatMode, setChatMode] = useState("TEXT");

  useEffect(() => {
    if (mode !== "CHAT") {
      setChatMode("TEXT");
    }
  }, [mode]);

  if (!userProfile) return null;
  const LearnerChatBubbleAny = LearnerChatBubble as any;

  return (
    <div className="qaw-root bg-catchup-mascot">
      <style>{mascotStyles}</style>
      <MascotWithItems
        hidden={chatMode === "AUDIO" && mode === "CHAT"}
        onClick={() => setShowText(true)}
        onLoad={onLoad}
        inventoryItemDTOList={inventoryItemDTOList}
      />

      {mode === "INFORMATION" ? (
        <>
          {/* Collapsed helper pill (design-system V4 "Need a hand?"): when an
              actionable offer exists but its bubble is closed, keep a small,
              non-blocking re-open affordance instead of a silent mascot. */}
          {!showText && primaryButtonText && (text || subText) ? (
            <button
              type="button"
              className="qaw-help-pill"
              onClick={() => setShowText && setShowText(true)}
            >
              {i18n.t("need_a_hand")}
            </button>
          ) : null}
          <InformationBubble
            showText={showText as boolean}
            setShowText={setShowText}
            text={text}
            subText={subText}
            primaryButtonText={primaryButtonText}
            primaryButtonOnClick={primaryButtonOnClick}
          />
        </>
      ) : mode === "CHAT" ? (
          <LearnerChatBubbleAny
            showText={showText}
            setShowText={setShowText}
            chatSize={chatSize}
            chatWelcomeText={chatWelcomeText}
            chatList={chatList}
            chatLoading={chatLoading}
            sendMessageOnClick={sendMessageOnClick}
            chatCanConvertAudio={chatCanConvertAudio}
            chatVoiceItemOwned={chatVoiceItemOwned}
            chatCanDraw={chatCanDraw}
            userInformation={userInformation}
            userProfile={userProfile}
            curriculumType={curriculumType}
            brandId={userProfileSeason.institutionDTO.campusDTO.brandDTO.id}
            campusId={userProfileSeason.institutionDTO.campusDTO.id}
            institutionId={userProfileSeason.institutionDTO.id}
            chatActivityId={chatActivityId}
            chatActivityTemplateId={chatActivityTemplateId}
            chatActivityTemplateType={chatActivityTemplateType}
            chatVoiceType={chatVoiceType}
            chatVoiceLanguage={chatVoiceLanguage}
            chatActType={chatActType}
            chatPosition={chatPosition}
            chatErrorText={chatErrorText}
            chatContinueText={chatContinueText}
            chatContinueOnClick={chatContinueOnClick}
            chatActionList={chatActionList}
          />
      ) : null}
    </div>
  );
};

export default Mascot;
